const formatUnixTimestamp = (unixTime: number, dateTimeFormat: string = 'en-US', isShowTime = true) => {
  const date = new Date(unixTime);
  
  const formattedDate = date.toLocaleDateString(dateTimeFormat);
  
  const formattedTime = date.toLocaleTimeString(dateTimeFormat);

  const time = isShowTime ? `\n ${formattedTime}` : '';

  return `${formattedDate} ${time}`;
}

export default formatUnixTimestamp;
